import { HttpClient } from '@angular/common/http';
import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild, } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router, } from '@angular/router';
import { getClickId } from 'src/app/shared/constants/app-enums';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-home-wrapper',
  templateUrl: './home-wrapper.component.html',
  styleUrls: ['./home-wrapper.component.scss'],
})
export class HomeWrapperComponent implements OnInit {
  constructor(private router: Router, private http: HttpClient) { }

  ngOnInit(): void {
    // if (this.router.url.includes('feature')) {
    //   window.scrollTo(0, document.getElementById('featureSection')?.offsetTop as number)
    // }
    // else if (this.router.url.includes('roadmap')) {
    //   window.scrollTo(0, document.getElementById('roadmapSection')?.offsetTop as number)
    // }
    // else if (this.router.url.includes('best-token-airdrop')) {
    //   window.scrollTo(0, document.getElementById('airdropSection')?.offsetTop as number)
    // }
    const clickId: string = getClickId();
    // if (clickId) {
    //   const w: any = window;
    //   const os = window.navigator.platform,
    //     version = window.navigator.userAgent,
    //     mobile = w?.navigator?.userAgentData.mobile;
    //   const data = {
    //     os,
    //     mobile,
    //     version,
    //     clickId
    //   };
    //   this.http.post(`${environment.bestWalletBackendURL}/dash-referral`, data).subscribe((res: any) => {
    //     console.log('success response', res);
    //   });
    // }
  }
}
